<template>
  <div>
    <v-breadcrumbs :items="crumbs"></v-breadcrumbs>
    <base-loader :isLoading="isLoading"></base-loader>
    <v-row>
      <v-col md="6">
        <v-card>
          <v-card-text>
            <h4 class="text-md-h4 primary--text mb-5">Organisation Details</h4>
            <v-simple-table v-if="$route.params.id != 0">
              <tbody>
                <tr>
                  <td>Organisation Name</td>
                  <td>
                    {{ organisationModel.name ? organisationModel.name : "" }}
                  </td>
                </tr>
                <tr>
                  <td>Organisation Id</td>
                  <td>
                    {{ organisationModel.id ? organisationModel.id : "" }}
                  </td>
                </tr>
              </tbody>
            </v-simple-table>

            <v-btn
              v-if="$route.params.id == 0"
              color="primary"
              large
              :to="`${$route.path}/edit`"
              class="mr-2"
              >Create a New Organisation</v-btn
            >
            <v-btn
              v-else
              large
              color="primary"
              :to="`${$route.path}/edit`"
              class="mr-2"
              >Edit</v-btn
            >
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { Organisation } from "@/models/Organisation";
import { gql } from "apollo-boost";
export default {
  data() {
    return {
      isEdit: false,
      organisationModel: new Organisation(),
      me: "",
      search: null,
      crumbs: [
        {
          text: "Organisations",
          disabled: false,
          href: "/admin/organisations",
        },
        {
          text: "Organisation Details",
          disabled: false,
          href: `/admin/organisation/${this.$route.params.id}`,
        },
      ],
    };
  },
  created() {},
  apollo: {
    me: gql`
      query {
        me {
          id
        }
      }
    `,
    organisation: {
      query: gql`
        query Organisation($id: ID!) {
          organisation(id: $id) {
            id
            name
            createdBy
            createdAt
            updatedAt
          }
        }
      `,
      fetchPolicy: "network-only",
      skip() {
        return !this.$route.params.id || this.$route.params.id == 0;
      },
      variables() {
        const self = this;
        return {
          id: self.$route.params.id,
          createdBy: self.me.id,
        };
      },
      watchLoading(isLoading) {
        this.isLoading = isLoading;
      },
      result(response, key) {
        this.isLoading = false;
        this.organisationModel.id = this.organisation.id;
        this.organisationModel.name = this.organisation.name;
        this.organisationModel.createdBy = this.organisation.createdBy;
      },
    },
  },
  methods: {},
};
</script>

<style lang="scss" scoped></style>
